module.exports = __webpack_public_path__ + "resources/img/img_t3q_search_en.3ecd174dc64d11b8c736e2d0dd249f58.png";